<app-kpi-details></app-kpi-details>
